import { SET_LOGIN_STATE } from "../../utils/constants/actionTypes"

const initialState= {
	error: null,
	statusError : false,
	success: false,
	successMsg : null,
	login : true,
	loading : false
}

const statusLogin = (state = initialState, action) => {
	switch(action.type){
		case SET_LOGIN_STATE: 
			return {
				...state,
				login : action.payload
			}
		default:
			return state
	}
}


export default statusLogin;